var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7497 8.83203C15.038 8.83203 12.0205 11.8495 12.0205 15.5612C12.0205 19.202 14.868 22.1487 18.5797 22.2762C18.693 22.262 18.8063 22.262 18.8913 22.2762C18.9197 22.2762 18.9338 22.2762 18.9622 22.2762C18.9763 22.2762 18.9763 22.2762 18.9905 22.2762C22.6172 22.1487 25.4647 19.202 25.4788 15.5612C25.4788 11.8495 22.4613 8.83203 18.7497 8.83203Z",
    fill: "url(#paint0_linear_3460_24849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9464 26.0466C21.9939 23.4116 15.548 23.4116 11.5672 26.0466C9.76803 27.2507 8.77637 28.8799 8.77637 30.6224C8.77637 32.3649 9.76803 33.9799 11.553 35.1699C13.5364 36.5016 16.143 37.1674 18.7497 37.1674C21.3564 37.1674 23.963 36.5016 25.9464 35.1699C27.7314 33.9657 28.723 32.3507 28.723 30.5941C28.7089 28.8516 27.7314 27.2366 25.9464 26.0466Z",
    fill: "url(#paint1_linear_3460_24849)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3193 16.3977C34.5459 19.146 32.5909 21.5543 29.8851 21.8802C29.8709 21.8802 29.8709 21.8802 29.8568 21.8802H29.8143C29.7293 21.8802 29.6443 21.8802 29.5734 21.9085C28.1993 21.9793 26.9384 21.5402 25.9893 20.7327C27.4484 19.4293 28.2843 17.4743 28.1143 15.3493C28.0151 14.2018 27.6184 13.1535 27.0234 12.261C27.5618 11.9918 28.1851 11.8218 28.8226 11.7652C31.5993 11.5243 34.0784 13.5927 34.3193 16.3977Z",
    fill: "url(#paint2_linear_3460_24849)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1527 29.5018C37.0393 30.8759 36.161 32.0659 34.6877 32.8734C33.271 33.6526 31.486 34.0209 29.7152 33.9784C30.7352 33.0576 31.3302 31.9101 31.4435 30.6918C31.5852 28.9351 30.7493 27.2493 29.0777 25.9034C28.1285 25.1526 27.0235 24.5576 25.8193 24.1184C28.9502 23.2118 32.8885 23.8209 35.311 25.7759C36.6143 26.8243 37.2802 28.1418 37.1527 29.5018Z",
    fill: "url(#paint3_linear_3460_24849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3460_24849",
    x1: 18.7497,
    y1: 8.83203,
    x2: 18.7497,
    y2: 22.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3460_24849",
    x1: 18.7497,
    y1: 24.0703,
    x2: 18.7497,
    y2: 37.1674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3460_24849",
    x1: 30.1632,
    y1: 11.7461,
    x2: 30.1632,
    y2: 21.9159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3460_24849",
    x1: 31.4937,
    y1: 23.707,
    x2: 31.4937,
    y2: 33.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapUserIcon);
export default __webpack_public_path__ + "static/media/map-user-icon.a855615abd3908536e7b11830820eb7d.svg";
export { ForwardRef as ReactComponent };